<template>
  <div id="the-dropdown">
    <el-dropdown @command="handleCommand">
      <div class="the-dropdown-content">
        <span class="user-name">{{ realname }}</span>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="pageLogout">注销</el-dropdown-item>
        <el-dropdown-item command="setPSD">修改密码</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dialog
      dialog-size="small"
      :visible.sync="isDialog"
      @close="handleCloseReset"
      title="修改密码">
      <div
        class="password"
        @keydown.enter="handleConfirm">
        <div class="password-item">
          <span>旧密码：</span>
          <base-input
            v-model="password.oldpassword"
            width="100%"
            :isTitle="false"
            type="password"
            clearable
          />
        </div>
        <div class="password-item">
          <span>新密码：</span>
          <base-input
            v-model="password.newpassword"
            width="100%"
            :isTitle="false"
            type="password"
            clearable
          />
        </div>
        <div class="password-item">
          <span>确认新密码：</span>
          <base-input
            v-model="password.confirmpassword"
            width="100%"
            :isTitle="false"
            type="password"
            clearable
          />
        </div>
      </div>
      <span slot="footer">
        <el-button
          color="blue"
          @click="handleCancel"
        >
          取 消
        </el-button>
        <el-button
          type="primary"
          @click="handleConfirm"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BaseInput from '@/components/BaseInput'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'TheDropdown',
  components: {
    BaseInput,
  },
  computed: {
    ...mapState([
      'realname',
    ]),
  },
  data () {
    return {
      isDialog: false,
      password: {},
    }
  },
  methods: {
    ...mapActions([
      'pageLogout',
      'changePassword',
    ]),
    handleCommand (command) {
      command === 'pageLogout' && this.pageLogout()
      command === 'setPSD' && (this.isDialog = true)
    },
    /**
     *@description               确定密码修改
     */
    async handleConfirm () {
      const { oldpassword, newpassword, confirmpassword } = this.password

      let tip = {
        oldpassword: '旧密码',
        newpassword: '新密码',
        confirmpassword: '确认新密码',
      }

      for (let k in tip) {
        if (!this.password[k]) {
          this.$message({
            message: `${tip[k]}不能为空`,
            type: 'warning',
          })
          return
        }
      }

      if (newpassword.length < 6) {
        this.$message({
          message: '新密码不能少于6位',
          type: 'warning',
        })
        return
      }

      if (newpassword !== confirmpassword) {
        this.$message({
          message: '确认新密码与新密码不一致',
          type: 'warning',
        })
        return
      }

      const params = {
        oldpassword,
        newpassword,
        confirmpassword,
      }

      const res = await this.changePassword(params)

      this.$notify({
        message: res.msg,
        type: res.code === 'success' ? 'success' : 'error',
      })

      res.code === 'success' && this.pageLogout()
    },
    // 打开修改密码弹窗
    handleCancel () {
      this.isDialog = false
    },
    handleCloseReset () {
      console.log(11111, this.password)
      this.password = {}
    },
  },
}
</script>

<style lang="less" scoped>
#the-dropdown {
  display: inline-block;
  vertical-align: middle;
  .the-dropdown-content {
    cursor: pointer;

    .user-name {
      color: #666;
      font-size: 14px;
      margin-right: 6px;
    }
  }
  /deep/ .el-dialog{
    min-width: 500px;
    .el-dialog__header{
      padding: 0px;
      height: 40px;
      line-height: 40px;
      background-color: #272d32;
      .el-dialog__title{
        margin-left: 25px;
        color: #fff;
        font-size: 15px;
      }
    }
    .el-dialog__headerbtn{
      top: 6px;
      .el-dialog__close{
        color: #fff;
        font-size: 30px;
      }
    }
    .el-dialog__body{
      padding: 0;
      color: #333;
      font-size: 15px;
    }
    .password {
      width: 80%;
      margin: 30px auto 0;
      .password-item {
        display: flex;
        margin-bottom: 20px;
        > span {
          display: inline-block;
          min-width: 100px;
          text-align: right;
        }
      }
      #base-input {
        width: 100%;
      }
    }
  }
}
</style>
